import { render, staticRenderFns } from "./DurationPicker.vue?vue&type=template&id=31e60c45&scoped=true"
import script from "./DurationPicker.vue?vue&type=script&lang=js"
export * from "./DurationPicker.vue?vue&type=script&lang=js"
import style0 from "./DurationPicker.vue?vue&type=style&index=0&id=31e60c45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e60c45",
  null
  
)

export default component.exports